import Layout from "@/layout";

const voucherManagerRoutes = [
  {
    path: "/voucherManager",
    component: Layout,
    meta: {title: '卡券管理', icon: 'setting'},
    children: [
      {
        path: "index",
        name: "voucherManager",
        component: () => import("@/views/voucherManager/index"),
        meta: {
          title: "卡券管理",
          icon: "component",
        },
      },
      {
        path: "voucherStat",
        name: "voucherStat",
        component: () => import("@/views/voucherManager/voucherStat"),
        meta: {
          title: "优惠券统计",
          icon: "chart",
        },
      },
    ],
  },
];

export default voucherManagerRoutes;
